import {
	HttpInterceptor,
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { LoginService } from './login.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	public constructor(private readonly loginService: LoginService) {}

	public intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap({
				next: (event: HttpEvent<any>) => of(event),
				error: (error: HttpErrorResponse) => {
					if (error.status === 401) {
						/*
						 * The backend can return a 401 status for services not related to authentication.
						 * You can differentiate them by checking `error.error` for a specific error code.
						 */
						this.loginService.login();
					}
				},
			})
		);
	}
}
